<template>
  <div class="col-xxl-12">
      <!--begin::Reorder History-->
  <div :class="widgetClasses" class="card">
    <!--begin::Header-->
    <div class="card-header border-0 pt-5">
      <h3 class="card-title align-items-start flex-column">
        <span class="card-label fw-bolder fs-3 mb-1">Bibo Activations</span>
      </h3>
    </div>
    <!--end::Header-->

    <!--begin::Body-->
    <div class="card-body py-3">
      <!--begin::Table container-->
      <div class="table-responsive">
        <!--begin::Table-->
        <table class="table align-middle gs-0 gy-4">
          <!--begin::Table head-->
          <thead>
            <tr class="fw-bolder text-muted bg-light">
              <th class="ps-4 min-w-125px rounded-start">Ref. #</th>
              <th class="min-w-200px">BIBO Code</th>
              <th class="min-w-225px">Endorser's Fullname</th>
              <th class="min-w-200px">Activation Date</th>
              <th class="min-w-200px">Action</th>
            </tr>
          </thead>
          <!--end::Table head-->
          <!--begin::Table body-->
          <tbody>
            <template v-for="(item, index) in list" :key="index">
              <tr>
                <td>{{index+1 }}</td>
                <td>{{item.bibocode}}</td>
                <td>{{item.endorser_fullname}}</td>
                <td v-if="item.endorser_cifid == 0 "></td>
                <td v-if="item.endorser_cifid != 0 ">{{item.activation_date}}</td>
                <td v-if="item.endorser_cifid == 0 ">
                  <button
                    type="button"
                    class="btn btn-success px-2 py-2"
                    data-bs-toggle="modal"
                    :data-bs-target="`#kt_register_endorser_modal_bibo`"
                    v-on:click="showEndorserRegistrationModal(item.bibo_codeid);"
                  >
                  Activate
                  </button>
                  <RegisterEndorserModalBibo widget-classes="card-xxl-stretch mb-5 mb-xxl-8"  :bibo_codeid="bibo_codeid"></RegisterEndorserModalBibo>
                </td>
                <td v-if="item.endorser_cifid != 0 "></td>
              </tr>
            </template> 
          </tbody>
          <!--end::Table body-->
        </table>
        <!--end::Table-->
      </div>
      <!--end::Table container-->
    </div>
    <!--begin::Body-->
     <pagination :pagination="pagination" :callback="reorderhistory" :options="paginationOptions"></pagination>
  </div>
  <!--end::Reorder History-->
    </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import pagination from 'vue-bootstrap-pagination'
import {loadPaginatedBiboActivationCodes}  from "@/api/bibo";
import RegisterEndorserModalBibo from "@/views/auth/RegisterEndorserModalBibo2.vue"

export default defineComponent({
  name: "biboactivations",
  components: {
    RegisterEndorserModalBibo
  },
  data() {
    return { 
      list : [],
      bibo_codeid : 0,
      pagination: {
        total: 0,
        per_page: 10,    // required
        current_page: 1, // required
        last_page: 0,    // required
        from: 1,
        to: 12
      }
    }
  },
  mounted(){
      this.getBiboActivationCodes();
  },
  methods : {
    async getBiboActivationCodes(){ 
      const options = {
        params: {
          paginate: this.pagination.per_page,
          page: this.pagination.current_page,
          /* additional parameters */
        }
      };
      const response = await loadPaginatedBiboActivationCodes(1);
      this.list = response.data.pageList;
      this.pagination = response.data.pagination;
      console.log(response.data.pageList);
    },
    async showEndorserRegistrationModal(bibo_codeid){
      this.bibo_codeid = bibo_codeid;
    }
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      // set the tab from previous
      tabIndex.value = parseInt(localStorage.getItem("biboActivationsTab") || "0");
      setCurrentPageTitle("Bibo Activations");

    });
    
  }
});
</script>
